import request from './request';

export interface LoginParams {
  username: string;
  password: string;
}

export interface UserInfo {
  id: number;
  username: string;
  nickname: string;
  role: string;
  status: string;
}

export function login(params: LoginParams): Promise<{ token: string; user: UserInfo }> {
  return request.post('/api/admin/v1/auth/login', params);
}

export function getProfile(): Promise<UserInfo> {
  return request.get('/api/admin/v1/auth/profile');
}

export function changePassword(data: {
  oldPassword: string;
  newPassword: string;
}): Promise<void> {
  return request.post('/api/admin/v1/auth/change-password', data);
}
